export const FETCH_SUCCESS = 'FAVORITE_FETCH_SUCCESS';
export const LOVE = 'FAVORITE_LOVE';
export const UNLOVE = 'FAVORITE_UNLOVE';
export const CLEAR = 'FAVORITE_CLEAR';
export const CLEAR_TOAST = 'CLEAR_TOAST';
export const UPDATE_FAVORITES_COUNT = 'UPDATE_FAVORITES_COUNT';
